export default "__VITE_ASSET__5c4a2035__"